import { Component, OnInit, Input } from '@angular/core';
import { DeviceManagementService } from '../device-management.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-reverse-calibration',
	templateUrl: './reverse-calibration.component.html',
})
export class ReverseCalibrationComponent implements OnInit {

	@Input() device: any = {};
	@Input() currentSite: any = {};

	constructor(
		private deviceManagementService: DeviceManagementService,
		private notificationMessage: NotificationMessageService,
		private translate: TranslateService,
		private commonService: CommonService,
	){}

	ngOnInit() {
		this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translate.instant('action_log.reverse_calibration')}`);
	}

	reverseCalibration(type = 'cancel') {
		this.deviceManagementService.reverseCalibration(this.device.mac_address, type).subscribe((data: any)=>{
			this.device.config_info = {...this.device.config_info, ...data};
			this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
		});
	};
}